import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localRead } from '@/libs/util'
import customZhCn from './lang/zh-CN'
import customZhTw from './lang/zh-TW'
import customEnUs from './lang/en-US'
import zhCnLocale from 'view-design/dist/locale/zh-CN'
import enUsLocale from 'view-design/dist/locale/en-US'
import zhTwLocale from 'view-design/dist/locale/zh-TW'
import jaJpLocale from 'view-design/dist/locale/ja-JP'
import i18 from '../store/module/i18n-manage'

Vue.use(VueI18n)
// 自动根据浏览器系统语言设置语言
const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false
let lang = localLang || localRead('local') || 'zh-CN'

Vue.config.lang = lang

/* const messages = {
  'zh-CN': Object.assign(zhCnLocale, customZhCn),
  'zh-TW': Object.assign(zhTwLocale, customZhTw),
  'en-US': Object.assign(enUsLocale, customEnUs),
  'ja-JP': Object.assign(jaJpLocale, customZhCn)
} */

const i18n = new VueI18n({
  locale: lang
})

i18.actions.getI18nAll().then(res => {
  if (res != null) {
    i18n.setLocaleMessage('zh-CN', Object.assign(Object.assign(zhCnLocale, res.cn)))
    i18n.setLocaleMessage('zh-TW', Object.assign(Object.assign(zhTwLocale, res.tw)))
    i18n.setLocaleMessage('en-US', Object.assign(Object.assign(enUsLocale, res.us)))
    i18n.setLocaleMessage('ja-JP', Object.assign(Object.assign(jaJpLocale, res.jp)))
  }
})
// vue-i18n 6.x+写法
Vue.locale = () => {}

export default i18n

// vue-i18n 5.x写法
// Vue.locale('zh-CN', Object.assign(zhCnLocale, customZhCn))
// Vue.locale('en-US', Object.assign(zhTwLocale, customZhTw))
// Vue.locale('zh-TW', Object.assign(enUsLocale, customEnUs))



// WEBPACK FOOTER //
// ./src/locale/index.js